import React, { createContext, useState, useContext, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const logging = () => {
    const result = JSON.parse(localStorage.getItem("token"));
    return result?.token;
  };

  return (
    <AuthContext.Provider value={{ logging }}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
